import type { ReactNode } from 'react';
import { useUserLoggedIn } from '~/modules/user/hook/use-user';
import { DirectoryIntro } from './DirectoryIntro';
import { DirectoryPromoBanner } from './DirectoryPromoBanner';

/** A full-width module injected into the directory grid at a fixed cadence. */
export interface DirectoryGridInjection {
    key: string;
    node: ReactNode;
}

/**
 * The modules injected into the directory grid, cycled in order at the grid's
 * injection cadence. Extend this list to add future injectable modules (e.g.
 * ads). The sign-in ("Unlock all features") module is only included for
 * logged-out users.
 */
export const useDirectoryGridInjections = (): DirectoryGridInjection[] => {
    const { isLoggedIn } = useUserLoggedIn();

    const injections: DirectoryGridInjection[] = [
        {
            key: 'get-matched',
            node: (
                <DirectoryIntro
                    variant="grid-injection"
                    eyebrow="Find the perfect solution"
                    heading="Can't find what you're after? Get Matched lets you describe what you need and have matching suppliers come to you."
                />
            ),
        },
    ];

    if (!isLoggedIn) {
        injections.push({ key: 'unlock', node: <DirectoryPromoBanner /> });
    }

    return injections;
};
